import React, { useContext, useEffect } from 'react';
import AppContext from '../../context/app/appContext';
import Post from './Post';
import Toolbox from './Toolbox';
import Asset from './Asset';
import NoResult from './NoResult';
import Loader from '../../components/Loader/Loader';
import LoadMore from '../../components/LoadMore/LoadMore';
import FadeIn from 'react-fade-in';

const Posts = () => {

  const appContext = useContext(AppContext);
  let { postType, getPosts, posts, loading, maxPages, params } = appContext;
  const {page} = params;
  let loadMore = false;

  const components = {
    news: Post,
    toolbox: Toolbox,
    asset: Asset
  };

  const Component = components[postType];

  useEffect(() => {
    getPosts();
  }, []);

  if(loading) {
    return <Loader/>;
  }

  if(!posts || posts.length === 0) {
    loadMore = false;
    return <NoResult />
  }

  loadMore = page < maxPages;

  return(
    <FadeIn>
      <div className={`js-component-archive-result component-archive-result row`}>
        {posts.map(post => <Component key={post.id} post={post} />)}
      </div>
      {loadMore &&
        <LoadMore/>
      }
    </FadeIn>
  )
}

export default Posts;



// WEBPACK FOOTER //
// ./src/components/Posts/Posts.js